/* 🤖 this file was generated by svg-to-ts */
export const matIconLabelImportant: {
  name: 'label-important';
  data: string;
} = {
  name: 'label-important',
  data: `<svg xmlns="http://www.w3.org/2000/svg" width="24" height="24"><path d="M4 18.99h11c.67 0 1.27-.32 1.63-.83L21 12l-4.37-6.16C16.27 5.33 15.67 5 15 5H4l5 7-5 6.99z"/></svg>`
};
